// extracted by mini-css-extract-plugin
export default {"containerDiv":"Dashboard_containerDiv__8+nEZ"};